document.addEventListener('DOMContentLoaded', () => {
    const xto_waitForCart = () => {
        if (!window.cart) {
            setTimeout(xto_waitForCart, 150)
            return
        }

        const xto_originalGetCart = window.cart.getCart ? window.cart.getCart.bind(window.cart) : null

        const xto_showToast = (message) => {
            const toast = document.querySelector('[data-cart-toast]')
            const toastText = document.querySelector('[data-cart-toast-text]')

            if (!toast || !toastText) return

            toastText.textContent = message
            toast.hidden = false

            requestAnimationFrame(() => {
                toast.classList.add('is-visible')
            })

            clearTimeout(toast.xto_timeout)
            toast.xto_timeout = setTimeout(() => {
                toast.classList.remove('is-visible')

                setTimeout(() => {
                    toast.hidden = true
                }, 250)
            }, 5000)
        }

        const xto_isPartialStockError = (response) => {
            if (!response) return false

            const xto_text = `${response.message || ''} ${response.description || ''}`.toLowerCase()

            return (
                xto_text.includes('debido a la disponibilidad') ||
                xto_text.includes('solo se añadieron') ||
                xto_text.includes('only added') ||
                xto_text.includes('quantity has been adjusted')
            )
        }

        const xto_handleSuccess = function(data, button) {
            if (data !== null && data.label) {
                data.label.classList.remove(this.settings.classes.hidden, this.settings.classes.loading)
                data.label.classList.add(this.settings.classes.added)
            }

            if (xto_originalGetCart) {
                xto_originalGetCart()
            }

            setTimeout(() => {
                if (button !== null) {
                    button.classList.remove(this.settings.classes.loading)
                    button.removeAttribute('disabled')
                    button.classList.add(this.settings.classes.success)
                }

                xto_showToast('Producto añadido al carrito')

                setTimeout(() => {
                    xto_showToast('Finalizar compra')
                }, 2000)
            }, this.settings.times.timeoutAddProduct)
        }

        const xto_handleError = function(response, data, button) {
            const xto_isPartialAdded = xto_isPartialStockError(response)

            if (xto_isPartialAdded && xto_originalGetCart) {
                xto_originalGetCart()
            }

            if (data !== null) {
                this.addToCartError(response, data.element, button)
            } else {
                this.addToCartError(response, null, button)
            }

            if (button !== null) {
                button.classList.remove(this.settings.classes.loading)
                button.removeAttribute('disabled')
            }

            if (xto_isPartialAdded) {
                setTimeout(() => {
                    xto_showToast('Añadidas unidades disponibles')

                    setTimeout(() => {
                        xto_showToast('Finalizar compra')
                    }, 2000)
                }, 300)
            }
        }

        if (window.cart.addToCart) {
            window.cart.addToCart = function(body, data = null, button = null) {
                this.form === null && data !== null && data.label && (this.form = data.label.parentNode.querySelector('form'))

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body
                })
                .then((response) => response.json())
                .then((response) => {
                    if (button) {
                        button.setAttribute('disabled', 'disabled')
                    }

                    if (response.status) {
                        xto_handleError.call(this, response, data, button)
                        return
                    }

                    xto_handleSuccess.call(this, data, button)
                })
                .catch((error) => {
                    console.error(error)
                })
            }
        }

        if (window.cart.addToCartWithExtras) {
            window.cart.addToCartWithExtras = function(body, data = null, button = null) {
                const form = button?.closest('form') || data?.element?.closest('form') || this.form;

                if (!form) {
                    console.error('No product form found');
                    return;
                }

                const mainVariantId = form.querySelector('[name="id"]')?.value;
                const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);

                if (!mainVariantId) {
                    console.error('No main variant id found');
                    return;
                }

                const items = [
                    {
                        id: Number(mainVariantId),
                        quantity: quantity
                    }
                ];

                form.querySelectorAll('[data-product-addons-item]:checked').forEach((input) => {
                    const variantId = input.dataset.variantId || input.value;

                    if (variantId) {
                        items.push({
                            id: Number(variantId),
                            quantity: 1
                        });
                    }
                });

                const requestBody = JSON.stringify({ items });

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: requestBody
                })
                    .then(async (response) => {
                        const text = await response.text();
                        let json = {};

                        try {
                            json = text ? JSON.parse(text) : {};
                        } catch (error) {
                            json = {};
                        }

                        if (!response.ok) {
                            console.error('Cart add error real:', response.status, json, text);

                            const errorResponse = {
                                status: response.status,
                                message: 'No se ha podido añadir al carrito',
                                description: json.description || json.message || 'Alguno de los productos seleccionados no se puede añadir al carrito.'
                            };

                            xto_handleError.call(this, errorResponse, data, button);
                            return;
                        }

                        if (button) {
                            button.setAttribute('disabled', 'disabled');
                        }

                        xto_handleSuccess.call(this, data, button);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            };
        }
    }

    xto_waitForCart()
})

document.addEventListener('DOMContentLoaded', () => {
    const xto_cleanDuplicatedCartErrors = () => {
        document.querySelectorAll('.product__form__errors .errors').forEach((error) => {
            const close = error.querySelector('[data-close-error]')
            const closeHtml = close ? close.outerHTML : ''
            const text = error.textContent.replace(/\s+/g, ' ').trim()

            const parts = text.split(': ')
            if (parts.length === 2 && parts[0] === parts[1]) {
                error.innerHTML = `${parts[0]}${closeHtml}`
            }
        })
    }

    document.addEventListener('click', () => {
        setTimeout(xto_cleanDuplicatedCartErrors, 100)
    })

    const xto_observer = new MutationObserver(() => {
        xto_cleanDuplicatedCartErrors()
    })

    xto_observer.observe(document.body, {
        childList: true,
        subtree: true
    })
})
